<template>
  <div>
    <SfAccordion
      :open="open"
      :multiple="multiple"
      :show-chevron="showChevron"
      :transition="transition"
    >
      <SfAccordionItem v-for="cart in list" :key="cart.Id" :header="cart.Name">
        <ShoppingListCart :cart="cart" />
      </SfAccordionItem>
    </SfAccordion>
  </div>
</template>

<script>
import { SfAccordion } from '@storefront-ui/vue';
import ShoppingListCart from './ShoppingListCart.vue';

export default {
  name: 'ShoppingList',
  components: {
    SfAccordion,
    ShoppingListCart,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      open: 'Clothing',
      multiple: true,
      showChevron: true,
      transition: 'sf-expand',
    };
  },
};
</script>
